import { render, staticRenderFns } from "./NexudusNotification.vue?vue&type=template&id=2a266301"
import script from "./NexudusNotification.vue?vue&type=script&lang=js"
export * from "./NexudusNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports